<div class="entity-create-page max-w-[600px]">
  <header class="mb-6">
    <h1 class="m-0 mb-3 text-3xl font-extrabold tracking-tight text-fg">New {{ entityConfig.label }}</h1>
    <button type="button" class="back inline-flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-[0.9375rem] font-semibold text-fg-secondary transition-colors hover:text-fg" (click)="goBack()">← Back</button>
  </header>
  <lib-dynamic-form
    [resourcePath]="listPath"
    (formSubmit)="onSubmit($event)"
    (cancel)="onCancel()"
  />
</div>
